/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralResolveDto
 */
export interface ReferralResolveDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralResolveDto
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralResolveDto
     */
    active: boolean;
}

export function ReferralResolveDtoFromJSON(json: any): ReferralResolveDto {
    return ReferralResolveDtoFromJSONTyped(json, false);
}

export function ReferralResolveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralResolveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'active': json['active'],
    };
}

export function ReferralResolveDtoToJSON(value?: ReferralResolveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'active': value.active,
    };
}

